// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__rALVA","loaderOuter":"PageOverlayLoader_loaderOuter__KvF8I"};